import { gql } from '@apollo/client'

export const GET_USER = gql`
    query get_user_data {
        get_user_data {
            first_name
            last_name
            email
            private_pricing_lots {
                lot_id
                pricing_type
            }
            vehicles {
                name
                manufacturer
                model
                vehicle_type
                plate_id
                id
            }
            license_plates {
                id
                plate
                country
            }
        }
    }
`
